module.exports = require("@bechtel/client-assets/dist/images/work-package.svg");